import { render, staticRenderFns } from "./DisplayResultsPanel.vue?vue&type=template&id=31da6af3&scoped=true"
import script from "./DisplayResultsPanel.vue?vue&type=script&lang=ts"
export * from "./DisplayResultsPanel.vue?vue&type=script&lang=ts"
import style0 from "./DisplayResultsPanel.vue?vue&type=style&index=0&id=31da6af3&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31da6af3",
  null
  
)

export default component.exports